// src/utils/printUtils.ts

export const printElement = (element: HTMLElement): void => {
  if (typeof window === 'undefined' || !element) return;
  
  // Явно указываем типы для TypeScript
  const doc = document as Document;
  
  const originalContent = doc.body.innerHTML;
  const printContent = element.innerHTML;
  
  // Настройка стилей печати
  doc.body.innerHTML = `
    <style>@media print { 
      body * { visibility: hidden; }
      #printSection, #printSection * { visibility: visible; }
      #printSection { position: absolute; left: 0; top: 0; width: 100%; }
      @page { size: A5; margin: 10mm; }
      #printSection table { width: 100%; border-collapse: collapse; }
      #printSection table, #printSection th, #printSection td { 
        border: 1px solid #000; padding: 5px; 
      }
    }</style>
    <div id="printSection">${printContent}</div>
  `;
  
  window.print();
  doc.body.innerHTML = originalContent;
  window.location.reload();
};